import OrganizationsTable from '../../Organizations/Index/OrganizationsTable';

export default function PaginatedOrganizations(props) {
  return(
    props.isLoading ? <div className="loading"></div> : <OrganizationsTable organizations={props.items} isNoData={props.isNoData} filters={props.filters} />
  );
};
